import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/pro-light-svg-icons';
import { Label } from '@shared/components/ui/label';
import { useTranslation } from 'react-i18next';

export const Features = () => {
  const { t } = useTranslation('suscriptionModule');
  return (
    <div className="space-y-4 mb-6 pb-8 gap-4 grid grid-cols-1 md:grid-cols-5 pt-4 border-b border-card-border">
      <div className="col-span-1 md:col-span-2">
        <Label className="text-lg font-semibold">{t('main.featuresTitle')}</Label>
      </div>
      <div className="col-span-1 md:col-span-3 !mt-0">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* 1 */}
          <div className="flex items-start gap-3">
            <FontAwesomeIcon icon={faCircleCheck} className="w-4 h-4 mt-1 flex-shrink-0 light:text-primary" />
            <div>
              <div className="font-semibold text-base mb-2">{t('main.featureMonthly')}</div>
              <div className="text-sm text-complementary-text">{t('main.featureMonthlyDesc')}</div>
            </div>
          </div>
          {/* 2 */}
          <div className="flex items-start gap-3">
            <FontAwesomeIcon icon={faCircleCheck} className="w-4 h-4 mt-1 flex-shrink-0 light:text-primary" />
            <div>
              <div className="font-semibold text-base mb-2">{t('main.featureOrders')}</div>
              <div className="text-sm text-complementary-text">{t('main.featureOrdersDesc')}</div>
            </div>
          </div>
          {/* 3 */}
          <div className="flex items-start gap-3">
            <FontAwesomeIcon icon={faCircleCheck} className="w-4 h-4 mt-1 flex-shrink-0 light:text-primary" />
            <div>
              <div className="font-semibold text-base mb-2">{t('main.featureUsers')}</div>
              <div className="text-sm text-complementary-text">{t('main.featureUsersDesc')}</div>
            </div>
          </div>
          {/* 4 */}
          <div className="flex items-start gap-3">
            <FontAwesomeIcon icon={faCircleCheck} className="w-4 h-4 mt-1 flex-shrink-0 light:text-primary" />
            <div>
              <div className="font-semibold text-base mb-2">{t('main.featureSupport')}</div>
              <div className="text-sm text-complementary-text">{t('main.featureSupportDesc')}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
